import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Canonical destination + anchor text for internal links to the weight-loss
 * peptide guide. Keeping both in one place means every related page sends the
 * same anchor-text signal to search engines.
 */
export const WEIGHT_LOSS_GUIDE_PATH = "/peptides/weight-loss";
export const WEIGHT_LOSS_GUIDE_ANCHOR = "clinical guide to peptides for weight loss";

export function WeightLossGuideLink({ className }: { className?: string }) {
  return (
    <Link
      to={WEIGHT_LOSS_GUIDE_PATH}
      className={cn("text-primary underline hover:no-underline", className)}
    >
      {WEIGHT_LOSS_GUIDE_ANCHOR}
    </Link>
  );
}

export default WeightLossGuideLink;
